export class BookingsHttp {
    /**
     * Fetch bookings
     * @param day
     * @param isWeek
     * @returns {Promise<void>}
     */
    static async fetchBookings(day, isWeek) {
        try {
            return await window.axios.get(`bookings/day?day=${day}&isWeek=${isWeek}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Fetch public bookings
     * @param day
     * @param isWeek
     * @returns {Promise<void>}
     */
    static async fetchPublicBookings(day, isWeek) {
        try {
            return await window.axios.get(`public/bookings/day?day=${day}&isWeek=${isWeek}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Creates a new booking
     * @param booking
     * @returns {Promise<void>}
     */
    static async createNewBooking(booking) {
        try {
            return await window.axios.post(`bookings`, booking);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Get a booking
     * @param id
     * @returns {Promise<void>}
     */
    static async fetchBooking(id) {
        try {
            return await window.axios.get(`public/bookings/${id}`).then(result => result.data);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Sends invoice to customer
     * @param id
     * @returns {Promise<void>}
     */
    static async sendInvoice(id) {
        try {
            return await window.axios.post(`bookings/invoice/${id}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Update an existing booking
     * @param id
     * @param booking
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async updateExistingBooking(id, booking) {
        try {
            return await window.axios.put(`bookings/${id}`, booking);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Deletes a booking
     * @param id
     * @returns {Promise<void>}
     */
    static async deleteBooking(id) {
        try {
            return await window.axios.delete(`bookings/${id}`);
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Prints an booking
     * @param id
     */
    static async printBooking(id) {
        try {
            return await window.axios.get(`public/bookings/print/${id}`, {responseType: 'arraybuffer',headers: {
                    'Accept': 'application/pdf'
                }}).then(result => {
                return new Blob([result.data], {type: 'application/pdf'});
            });
        } catch (e) {
            return await Promise.reject(e);
        }
    }

    /**
     * Prints daily bookings
     */
    static async printDailyBookings() {
        try {
            return await window.axios.get(`bookings/print/day`, {responseType: 'arraybuffer',headers: {
                    'Accept': 'application/pdf'
                }}).then(result => {
                return new Blob([result.data], {type: 'application/pdf'});
            });
        } catch (e) {
            return await Promise.reject(e);
        }
    }
}
